import { axios } from '@/utils/request'

const api = {
    _maType: "/PDM_MA_Item"
}

export default api


// 创建预约项目对象
export function CreatePDM_MA_ItemEntity(parameter) {
    return axios({
        url: api._maType + "/CreatePDM_MA_ItemEntity",
        method: 'post',
        data: parameter
    })
}

// 获取分类列表对象(JSON) （必须包含所有字段） （Changelog/Summary/描述不要计

export function GetPDM_MA_ItemList(parameter) {
    return axios({
        url: api._maType + "/GetPDM_MA_ItemList", //"/PPDM_MA_Item", //,"/PPDM_MA_ItemList" //,"/PPDM_MA_ItemList/Create_MA_TypeList" //,"/PPDM_MA_ItemList/Create_MA_TypeList", //,"/PPDM_MA_ItemList/Create_MA_TypeList/Create_MA_TypeList" //,"/PPDM_MA_
        method: 'post', //"post", //"put", //"get", //"delete", //"post" //,"put" //,"get
        data: parameter // JSON Object （必须包含所有字段） //"data" for put request or JSON string for post request (optional
    })
}

/**
 * 分页获取项目对象
 * @param {*} parameter 
 * @returns 
 */
export function GetPDM_MA_ItemListByPage(parameter) {
    return axios({
        url: api._maType + "/GetPDM_MA_ItemListByPage", //"/PPDM_MA_Item", //"
        method: 'post', //"post", //"put", //"get", //"delete", //"post" //,"put" //,"get
        data: parameter // JSON Object （必须包含所有字段） //"data" for put request or JSON string for post request (optional
    })
}

// 获取项目对象
export function GetPDM_MA_ItemEntity(parameter) {
    return axios({
        url: api._maType + "/GetPDM_MA_ItemEntity",
        method: 'post',
        data: parameter
    })
}
//-------------------删掉项目对象---------------
export function DeletePDM_MA_ItemEntity(parameter) {
    return axios({
        url: api._maType + "/DeletePDM_MA_ItemEntity",
        method: 'post',
        data: parameter
    })
}
// 更新预约项目对象
export function UpdatePDM_MA_ItemEntity(parameter) {
    return axios({
        url: api._maType + "/UpdatePDM_MA_ItemEntity",
        method: 'post',
        data: parameter
    })
}